import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Editor from './pages/Editor';
import FlowListPage from './pages/FlowListPage';
import FlowPreview from './pages/FlowPreview';
import ResponsiveLayout from './layouts/ResponsiveLayout'; // 👈 nuevo

function App() {
  return (
    <ResponsiveLayout>
      <Routes>
        <Route path="/" element={<Editor />} />
        <Route path="/flows" element={<FlowListPage />} />
        <Route path="/preview" element={<FlowPreview />} />
      </Routes>
    </ResponsiveLayout>
  );
}

export default App;
